<div class="page-header">
  <div class="page-container">
    <div class="page-header__content">
      <div class="page-header__info">
        <h2 class="page-header__title">{{ "Članovi Organizacije" | translate }}</h2>
        <span class="page-header__subtitle">{{
          "usersSubtitle" | translate
        }}</span>
      </div>

      <div class="page-header__actions">
        <button nz-button [nzType]="'primary'" (click)="new()">
          {{ "Članovi Organizacije" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div class="page-container">
  <div class="page-content">
    <form (submit)="searchUsers()">
      <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
        <input
          type="text"
          nz-input
          [formControl]="searchQueryControl"
          [placeholder]="'searchUsers' | translate"
        />
      </nz-input-group>
      <ng-template #suffixIconButton>
        <button nz-button nzType="primary" nzSearch>
          <i class="far fa-search"></i>
        </button>
      </ng-template>
    </form>

    <nz-table
      class="mt-2"
      #basicTable
      [nzData]="data"
      [nzLoading]="isLoading"
      [nzFrontPagination]="false"
      [nzTotal]="tableData.total"
      [nzPageSize]="tableData.pageSize"
      [nzPageIndex]="tableData.page"
      (nzQueryParams)="tableParamsChanged($event)"
    >
      <thead>
        <tr>
          <!-- <th nzWidth="50px">ID</th> -->
          <th>{{ "name" | translate }}</th>
          <th>{{ "dateOfBirth" | translate }}</th>
          <th>{{ "email" | translate }}</th>
          <th>{{ "phone" | translate }}</th>
          <th>{{ "note" | translate }}</th>
          <th>{{ "joined" | translate }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of basicTable.data">
          <!-- <td>{{ data.id }}</td> -->
          <td>{{ data.name }}</td>
          <td>{{ data.dateOfBirth | date }}</td>
          <td>{{ data.email }}</td>
          <td>{{ data.phone }}</td>
          <td>{{ data.note }}</td>
          <td>{{ data.joined |date }}</td>
          <td class="text-right">
            <button nz-button nzSize="small" (click)="edit(data.id)">
              <i class="far fa-pen"></i>
            </button>

            <button
              nz-button
              nzSize="small"
              class="ml-2"
              (click)="delete(data.id)"
            >
              <i class="far fa-trash"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</div>
